module.exports = __webpack_public_path__ + "img/btn_facai.b9038140.png";